import {useInfiniteQuery} from "@tanstack/react-query";

import {ITEMS_PER_PAGE} from "@/lib/utils";
import {ParamsOptions} from "@/src/modules/core/types";

import {propertiesService} from "../services";

export function useInfiniteProperties(
  options: ParamsOptions = {
    sort: "name",
  },
) {
  const {data, ...query} = useInfiniteQuery({
    queryKey: ["infinite-properties", options],
    queryFn: ({pageParam = 0}) => {
      const page = {
        limit: ITEMS_PER_PAGE,
        offset: pageParam,
      };
      return propertiesService.getProperties({...options, page});
    },
    getNextPageParam: (lastPage, pages) => {
      const loadedItems = pages.reduce((acc, page) => acc + page.data.length, 0);
      return loadedItems < lastPage.meta.total ? loadedItems : undefined;
    },
    initialPageParam: 0,
  });

  const properties = data?.pages.flatMap((page) => page.data) ?? [];

  return {
    properties,
    ...query,
  };
}
